<template>
  <v-card class="pa-2" flat>
    <template v-if="!showUploadBtn && !onChange">
      <v-card-text class="pa-0">
        <v-file-input ref="fileInput" v-model="filesModel" :loading="loading" accept="video/mp4" class="d-none"
                      clearable truncate-length="7" @change="handleFileUpload" @click:clear="filesModel = null"/>
      </v-card-text>

      <v-card id="uploader" ref="uploader" :loading="loading"
              class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden" height="200"
              max-width="700" outlined @click="dragEvent" @dragleave="dragEvent" @dragover="dragEvent"
              @drop="dragEvent">
        <v-icon size="68" style="opacity: .4">mdi-cloud-upload-outline</v-icon>
        <v-card-title class="justify-center">آپلود فایل</v-card-title>
        <v-card-text class="text-center pt-0">
          برای آپلود بکشید و رها کنید یا
          <v-btn :loading="loading" class="mx-1" color="primary" min-width="75" small>
            اینجا
          </v-btn>
          کلیک کنید
        </v-card-text>
      </v-card>
    </template>

    <template v-else-if="(!!filesModel) || (!!value && !!value.images && !!value.images.length)">
      <v-card class="d-flex flex-wrap mx-auto pa-2" flat>
        <v-row justify="center" no-gutters>
          <v-col class="text-center d-flex justify-space-between flex-column pa-2" cols="12" md="4"
                 style="max-width: 300px;width: 300px">
            <video controls muted>
              <source :src="filesPreview.url" type="video/mp4">
              Your browser does not support the video tag.
            </video>

            <div v-if="!upLoading && !filesPreview.color" class="d-flex flex-nowrap justify-space-between w-100">
              <span class="pa-2">{{ filesPreview.name }}</span>

              <v-btn icon @click="removeFileFromUpload(0)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>

            <v-card v-else-if="!!filesPreview.color" class="d-flex rounded-top-0 align-center justify-center pa-2"
                    color="rgba(0, 0, 0, .5)" flat width="100%">
              <v-avatar :color="filesPreview.color">
                <v-icon>mdi-{{ !!filesPreview.status ? 'check' : 'close' }}</v-icon>
              </v-avatar>
            </v-card>
          </v-col>

          <v-col class="pa-2" cols="12" md="8">
            <v-text-field v-model="filesPreview.name" class="my-2" dense label="عنوان" outlined/>

            <v-textarea v-model="filesPreview.description" class="my-2" dense label="توضیحات" outlined/>

            <v-row no-gutters>
              <v-col cols="12" md="6">
                <v-text-field v-model="tempTag" clear-icon="mdi-close-circle-outline" clearable dense label="برچسب"
                              outlined @keydown.enter="[filesPreview.tag.push(tempTag), tempTag = '']">
                  <template v-slot:append>
                    <v-btn class="mt-n1" color="primary" small text
                           @click="[filesPreview.tag.push(tempTag), tempTag = '']">
                      <v-icon>mdi-plus</v-icon>
                      افزودن
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-card-text class="py-1" v-text="'#برچسب/ها'"/>
                <v-card-title class="py-1">
                  <v-chip v-for="(tag, i) in filesPreview.tag" :key="i" class="mx-1" link small v-text="tag"/>
                </v-card-title>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>

      <v-card-actions class="justify-center">
        <v-btn v-if="showUploadBtn && !upLoading" :disabled="!canUploadVideo" class="rounded-lg"
               color="primary" depressed min-width="50%" @click="uploadFiles">
          آپلود فایل/ها
        </v-btn>

        <div v-else class="w-100">
          <v-progress-linear :value="progress" height="25" rounded>
            <template v-slot:default="{ value }">
              <strong>{{ Math.ceil(value) }}%</strong>
            </template>
          </v-progress-linear>
          <p class="text-center">بارگزاری...</p>
        </div>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
import {qrAxios} from "@/main";

export default {
  name: "videoUploadHandler",

  props: {
    value: [Array, Object],
    onChange: Boolean
  },

  data: () => ({
    // errors: '',
    filesModel: null,
    filesPreview: {},
    loading: false,
    progress: 0,
    upLoading: false,
    uploadErrors: {},
    tempTag: ''
  }),

  computed: {
    computedValue: {
      get() {
        return this.onChange ? this.value : this.filesModel
      },
      set(val) {
        this.filesModel = val
      }
    },
    showUploadBtn() {
      return !!this.computedValue
    },
    canUploadVideo() {
      return !!this.filesPreview?.name && this.filesPreview?.description?.length >= 3
        && !!this.filesPreview.tag?.length
    }
  },

  watch: {
    value(val) {
      this.filesModel = val
      this.handleFileUpload(val)
    }
  },

  methods: {
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();

      let uploader = this.$refs.uploader
      if (e.type === 'dragover' && !uploader.$el.classList.contains('drag-over'))
        uploader.$el.classList.add('drag-over')
      else if (e.type === 'dragleave' && uploader.$el.classList.contains('drag-over'))
        uploader.$el.classList.remove('drag-over')
      else if (e.type === 'drop') {
        uploader.$el.classList.remove('drag-over');
        const files = e.target.files || e.dataTransfer.files
        // let arr = []
        // if (this.onePic) {
        //   try {
        //     arr.push(files[0])
        //   } catch (e) {
        //
        //   }
        // } else {
        // for (const file of files) {
        //   arr.push(file)
        // }
        // }
        this.filesModel = files
        this.handleFileUpload(files)
      } else if (e.type === 'click') {
        this.$refs.fileInput.$refs.input.click()
      }
    },
    handleFileUpload(event) {
      console.log('handleFileUpload: ', event)

      // let arr = event
      // if (!!arr && !!arr.length) {
      // this.errors = arr.filter(e => e.size > 2000000).length > 0
      //   ? 'حداکثر حجم هر تصویر پس زمینه نظر می‌تواند 2 مگابایت باشد.'
      //   : ''

      // for (const file of arr) {
      const reader = new FileReader();
      reader.onload = function (e) {
        console.log('e: ', e)
        this.filesPreview = {
          src: e.target.result,
          url: e.target.result,
          // name: file.name,
          name: '',
          description: '',
          tag: []
        }
      }.bind(this)
      reader.readAsDataURL(event);
      // }
      // }
      this.$forceUpdate()
    },
    removeFileFromUpload(index = 0) {
      // if (typeof this.filesModel === 'object')
      this.filesModel = null
      if (this.onChange) this.$emit('input', '')
      // else
      //   this.filesModel = null

      // this.filesToUpload.splice(index, 1);
      this.filesPreview = {}
    },
    async uploadFiles() {
      if (this.filesModel instanceof Array)
        for (const file of this.filesModel) {
          await this.uploadToServer(file)
        }
      else
        await this.uploadToServer(this.filesModel)
    },
    async uploadToServer(file) {
      const formData = new FormData();
      this.upLoading = true

      let index = 0
      if (this.filesModel instanceof Array)
        index = this.filesModel.indexOf(file)

      formData.append('file', file);
      formData.append('title', this.filesPreview.name);
      formData.append('description', this.filesPreview.description);
      formData.append('tag', this.filesPreview.tag.join(','));

      try {
        await qrAxios.post('/user/aparat', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (e) => {
            this.progress = Math.round((e.loaded / e.total) * 100);
          }
        })
          .then(response => {
            this.filesPreview.status = true
            this.filesPreview.color = 'success'

            if (this.onChange || typeof this.filesModel !== 'object'
              || (!!this.filesModel.length && index + 1 >= this.filesModel.length)) {
              this.filesModel = null
              this.filesPreview = {}
              this.$toast.success('با موفقیت آپلود شد.');
              // this.tabs = 1
              // this.page = 1
              // this.img.items = []
              setTimeout(() => {
                this.$emit('fetch')
              }, 500)
            }
          })
          .catch(error => {
            this.filesPreview.status = false
            this.filesPreview.color = 'error'
            this.$toast.error('خطای آپلود ویدئو!')
          })
          .finally(() => this.upLoading = false)
        this.upLoading = false
      } catch (e) {
        this.upLoading = false
      }

    },
  }
}
</script>

<style scoped>
#uploader {
  transition: all .3s ease;
  background-color: rgba(0, 0, 0, .2);
  border: 2px dashed #5b5b5b !important;
}

.drag-over {
  border: 2px dashed #fff !important;
  background-color: rgba(33, 150, 243, .33) !important;
}
</style>